import { useRemoveProductMutation } from "../store"
import Button from "./Button"
import { GoTrash } from "react-icons/go"

const ProductsListItem = ({ product }) => {
  const [removeProduct, resultRemoveProduct] = useRemoveProductMutation()

  const handleRemoveProduct = () => {
    removeProduct(product)
  }

  return (
    <div className="p-4 mt-4">
      <div className="p-3 flex flex-row justify-between items-center">
        <h3>{product.name}</h3>
        <div>{product.price}</div>
        <Button
          onClick={handleRemoveProduct}
          loading={resultRemoveProduct.isLoading}>
          <GoTrash />
        </Button>
      </div>
    </div>
  )
}

export default ProductsListItem
